import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type RadioChoice = {
    text: string;
    value: any;
};

@Component({
    selector: 'radio-choice',
    template: `
        <div
            class="
                btn-group
                btn-group-sm
                btn-group--radio
                btn--lsg--group
                continuous-button-group
            "
            role="group"
            aria-label="..."
            [ngStyle]="{ 'z-index': zIndex }"
        >
            @for (entry of possibleValues; track entry) {
                <button
                    type="button"
                    class="button button-sm"
                    (click)="myValue = entry.value"
                    [ngClass]="{
                        'button-primary': myValue === entry.value,
                        'button-tertiary': myValue !== entry.value
                    }"
                    [disabled]="disabled"
                    [innerHTML]="entry.text"
                ></button>
            }
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RadioChoiceComponent,
            multi: true
        }
    ],
    standalone: false
})
export class RadioChoiceComponent implements ControlValueAccessor {
    @Input()
    possibleValues: RadioChoice[];
    @Input()
    zIndex: 'auto' | number = 1;

    propagateChange = (_: any) => {
        /* No change propagated */
    };
    private _myValue: any;
    disabled: boolean;

    get myValue() {
        return this._myValue;
    }
    set myValue(val) {
        this._myValue = val;
        this.propagateChange(this._myValue);
    }

    writeValue(value: any): void {
        this._myValue = value;
    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }
}
